import { useNavigate } from "react-router-dom";
import useFormStatutorydoc from "../Libs/useVesselOwnerStaDoc";
import { ReactComponent as UploadIcon } from "../../Asset/upload-cloud-02.svg";
import Spinner from "../../Utils/spinner/loading";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import { CiFileOn } from "react-icons/ci";
import { useContext, Fragment, useState } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";

const VesselOwnerStatutoryDoc = () => {
  const navigate = useNavigate();
  const { handleSubmit, loading, error, success } = useFormStatutorydoc();
  const { token, logout } = useContext(AuthContext);
  const [saving, setSaving] = useState(false);

  const [formData, setFormData] = useState({
    businessRegistration: null,
    marad: null,
  });
  const [fileDetails, setFileDetails] = useState({
    businessRegistration: null,
    marad: null,
  });

  const handleFileChange = (e, fieldName) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      [fieldName]: file,
    });

    const fileDetail = {
      name: file.name,
      size: file.size,
    };
    setFileDetails({
      ...fileDetails,
      [fieldName]: fileDetail,
    });
  };

  const handleFileDelete = (fieldName) => {
    setFormData({
      ...formData,
      [fieldName]: null,
    });
    setFileDetails({
      ...fileDetails,
      [fieldName]: null,
    });
  };

  const handleFinish = (e) => {
    e.preventDefault();
    handleSubmit(e, formData);
  };

  const handleSaveLogout = async (e) => {
    e.preventDefault();
    setSaving(true); // Set saving to true when the file upload starts

    const formDataToSend = new FormData();
    formDataToSend.append(
      "businessRegistration",
      formData.businessRegistration
    );
    formDataToSend.append("marad", formData.marad);
    // formDataToSend.append("signature", formData.signature); // Uncomment if signature is needed

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/vesselOwner/profile/upload/statutoryDocs`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formDataToSend,
        }
      );

      if (response.ok) {
        // Handle success
        toast.success("Documents uploaded successfully!");
        logout(); // Logout after successful upload
      } else {
        // Handle error
        toast.error("Failed to upload documents!");
      }
    } catch (error) {
      console.error("Error uploading documents:", error);
      toast.error("Error uploading documents!");
    } finally {
      setSaving(false); // Reset saving state
    }
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };

  return (
    <Fragment>
      <ToastContainer />
      <div className="statutory-container">
        <div className="wrap">
          <div className="header">
            <button onClick={() => navigate("/updates")}>Back</button>
            {/* <Link to="/">Vessel Owner</Link> */}
            <BlackVatugIcon onClick={() => navigate("/")} />
            <button
              className="finished"
              disabled={saving}
              onClick={handleSaveLogout}
            >
              {saving ? "Saving... & Logging out" : "Save & Log out"}
            </button>
          </div>
          <form>
            <h2>Statutory Documents</h2>

            {/* Business Registration */}
            {!fileDetails.businessRegistration && (
              <label>
                Business Registration e.g CAC
                <span>
                  <input
                    type="file"
                    hidden
                    accept="application/pdf" // Accept PDF files only
                    onChange={(e) =>
                      handleFileChange(e, "businessRegistration")
                    }
                  />
                  <>
                    <UploadIcon />
                    <p>
                      Drop pdf here, <span>or browse</span>
                    </p>
                    <h5>Supports: PDF</h5>
                  </>
                </span>
              </label>
            )}

            {fileDetails.businessRegistration && (
              <div className="uploaded">
                <div className="wrap">
                  <CiFileOn className="file" />
                  <div className="in">
                    <span>
                      <h3>{fileDetails.businessRegistration.name}</h3>
                    </span>
                    <p>
                      {formatFileSize(fileDetails.businessRegistration.size)} -
                      100% Uploaded
                    </p>
                  </div>
                </div>
                <div className="last">
                  <IoCheckmarkDoneCircleOutline className="mark" />
                  <RiDeleteBin5Line
                    onClick={() => handleFileDelete("businessRegistration")}
                    className="delete"
                  />
                </div>
              </div>
            )}

            {/* Marad */}
            {!fileDetails.marad && (
              <label>
                Marad e.g NIMASA
                <span>
                  <input
                    type="file"
                    hidden
                    accept="application/pdf" // Accept PDF files only
                    onChange={(e) => handleFileChange(e, "marad")}
                  />
                  <>
                    <UploadIcon />
                    <p>
                      Drop pdf here, <span>or browse</span>
                    </p>
                    <h5>Supports: PDF</h5>
                  </>
                </span>
              </label>
            )}

            {fileDetails.marad && (
              <div className="uploaded">
                <div className="wrap">
                  <CiFileOn className="file" />
                  <div className="in">
                    <span>
                      <h3>{fileDetails.marad.name}</h3>
                    </span>
                    <p>
                      {formatFileSize(fileDetails.marad.size)} - 100% Uploaded
                    </p>
                  </div>
                </div>
                <div className="last">
                  <IoCheckmarkDoneCircleOutline className="mark" />
                  <RiDeleteBin5Line
                    onClick={() => handleFileDelete("marad")}
                    className="delete"
                  />
                </div>
              </div>
            )}

            <button
              className="finished"
              onClick={handleFinish}
              disabled={loading}
            >
              {loading ? <Spinner /> : "Next"}
            </button>

            {error && (
              <p
                style={{
                  margin: "auto",
                  color: "red",
                  fontFamily: "Montserrat",
                }}
              >
                {error}
              </p>
            )}
            {success && (
              <p
                style={{
                  margin: "auto",
                  color: "green",
                  fontFamily: "Montserrat",
                }}
              >
                {success}
              </p>
            )}
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default VesselOwnerStatutoryDoc;
